<script lang="ts">
  import type { Facet } from "@otto-ec/heureka-components/facet";
  import { Scrollable } from "@otto-ec/heureka-components/facet";

  interface Props extends Facet {
    mode?: "filterAccordion" | "detailSheet";
  }

  const { mode = "filterAccordion", ...facet }: Props = $props();
</script>

{#if mode === "detailSheet"}
  <Scrollable {...facet} scrollable={false} />
{:else}
  <Scrollable {...facet} />
{/if}
